<template>
    <div v-if="shortCutNav.length > 0">
        <span v-for="(nav, key) in shortCutNav" :key="key" 
              v-if="user_id === nav.user_id">

            <a v-if="nav.private?nav.private === userCompany:true"
                class="btn btn-sm rounded-pill mr-2 custom-style" :href="nav.url">
                {{nav.name}}
            </a>
        </span>
    </div>
</template>

<script>
export default {
  name: 'ShortcutNavigation',
  props: {user_id: Number, roles: Array},
    data() {
        return {
            shortCutNav: [],
            showMore: [],
        }
    },
  computed:{
    userCompany(){
      return this.$store.state.user.loggedInUser.company_id;
    },
  },
    mounted() {
        // let nav = JSON.parse(localStorage.getItem("shortCutNavigation") || "[]");
        // this.shortCutNav = [
        //         // { "name": 'Dashboard', "url": '/admin/dashboard', "count": 1, "user_id": this.user_id},
        //         // { "name": 'Tasks', "url": '/kanban-view', "count": 1, "user_id": this.user_id},
        //         // { "name": 'Certificates', "url": '/buyer/certificates', "count": 1, "user_id": this.user_id},
        //         // { "name": 'My Document', "url": '/admin/documentlibrary/mydocument', "count": 1, "user_id": this.user_id},
        //         // { "name": 'Workspace', "url": '/admin/workspaces', "count": 1, "user_id": this.user_id, 'private': 1}
        //     ];
        //
        // // Sort the shortcuts by count in descending order
        // nav.sort((a, b) => b.count - a.count);
        //
        //  // Return the top 8 shortcuts
        //  let navNewValues =  nav.slice(0, 8);
        //
        // if(!this.getCustomerRole()){
        // this.shortCutNav = this.shortCutNav.concat(navNewValues);
        // }else{
        //   this.shortCutNav = navNewValues
        // }
      let nav = JSON.parse(localStorage.getItem("shortCutNavigation") || "[]");

// Assuming you have a method to get the current user ID
      let userId = null;
      if (this.user_id) {
        userId = this.user_id;
      }

      let userRoles = this.roles; // Assuming userRoles is available in the component data

      let rolesString = JSON.stringify(userRoles);

// Filter shortcuts based on user ID and role
      let filteredNav = nav.filter(navItem => navItem.user_id === userId && navItem.role === rolesString);

// Sort the filtered shortcuts by count in descending order
      filteredNav.sort((a, b) => b.count - a.count);

// Return the top 8 shortcuts
      let navNewValues = filteredNav.slice(0, 8);

      if (!this.getCustomerRole()) {
        this.shortCutNav = this.shortCutNav.concat(navNewValues);
      } else {
        this.shortCutNav = navNewValues;
      }

    },
  methods:{
    getCustomerRole(){
      const valuesArray = Object.values(this.roles);
      return valuesArray.includes('Customer');
    }
  }
}
</script>
<style>
.custom-style {
    color: #292f4c !important;
    /* border-color: #292f4c; */
    background-color: #fff !important;
    box-shadow: 0px 0px 10px rgba(61, 61, 61, 0.24);
    padding: 5px 10px !important;
    border-radius: 5px !important;
    margin-right: 8px !important;
    margin-bottom: 8px !important;
}
.custom-style:hover {
    /* background-color: #292f4c!important; */
    background: linear-gradient(90deg, rgba(38,47,76,1) 35% , #8b8b8b 100%);
    /* border-color: #292f4c; */
    color: #fff !important;
    box-shadow: 0px 0px 10px rgba(61, 61, 61, 0.24)
}


</style>